import { useState } from "react";

import { AsyncState, Button, Link } from "@shapr3d/frontend-lib";

import { supportEmail } from "../../config";
import useNavigation from "../../hooks/navigation";
import useTranslation from "../../hooks/useTranslation";
import Heading from "../Heading/Heading";

import style from "./ZendeskEmailVerify.module.css";

export interface ZendeskEmailVerifyProps {
  onResendClick: () => void;
}

const ZendeskEmailVerify = (props: ZendeskEmailVerifyProps) => {
  const navigation = useNavigation();
  const { t, m } = useTranslation();
  const [verifyResendState, setVerifyResendState] = useState(AsyncState.Initial);

  const onResendClick = async () => {
    setVerifyResendState(AsyncState.Pending);
    try {
      await props.onResendClick();
      setVerifyResendState(AsyncState.Done);
    } catch (err) {
      setVerifyResendState(AsyncState.Error);
    }
  };

  const content = (() => {
    switch (verifyResendState) {
      case AsyncState.Initial:
      case AsyncState.Pending:
        return (
          <Button
            onClick={onResendClick}
            className={style.button}
            disabled={verifyResendState === AsyncState.Pending}
          >
            {t(m.ZendeskEmailVerify.ResendEmail)}
          </Button>
        );
      case AsyncState.Done:
        return <div className={style.text}>{t(m.ZendeskEmailVerify.EmailSent)}</div>;
      case AsyncState.Error:
        return (
          <div className={style.text}>
            {t(m.ZendeskEmailVerify.SomethingWentWrong, {
              email: () => <Link href={`mailto:${supportEmail}`}>{supportEmail}</Link>,
            })}
          </div>
        );
    }
  })();

  return (
    <div className={style.container}>
      <div className={style.content}>
        <Heading type="h1">{t(m.Edu.TitleVerifyEmail)}</Heading>
        <div className={style.text}>{t(m.ZendeskEmailVerify.Description)}</div>
        {content}
        <Button
          onClick={() => navigation.goToProfile()}
          variant="grayscale"
          className={"back-to-account"}
        >
          {t(m.ZendeskEmailVerify.BackToAccount)}
        </Button>
      </div>
    </div>
  );
};

export default ZendeskEmailVerify;
